import {
  AlertBox,
  Button,
  DatePicker,
  TimePicker,
} from "@life-line-lab/components-react";
import React, { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import errorHandler from "Utils/error-handler";
import { Moment } from "moment";
import moment from "moment";
import { Col, Row } from "antd";
import { CalendarOutlined } from "@ant-design/icons";
import { PickupDateModalSchema } from "./pickup-date-modal-validation";

type InputData = {
  pickupDateTime: Moment | null;
};

type SubmitData = { pickupDateTime: Moment | string; orderID: string };

interface PickupDateModalProps {
  onClose: () => void;
  onSubmit: (data: SubmitData) => void;
  initialPickupDateTime: Moment | null;
  orderID: string;
  error: any;
  setError: React.Dispatch<React.SetStateAction<any[]>>;
  isLoading: boolean;
}

const PickupDateModal: FC<PickupDateModalProps> = (props) => {
  const {
    onClose,
    onSubmit,
    initialPickupDateTime,
    orderID,
    setError,
    error,
    isLoading,
  } = props || {};

  const { t } = useTranslation();

  const [input, setInput] = useState<InputData>({
    pickupDateTime: initialPickupDateTime,
  });

  const handleDateChange = (date: Moment | null) => {
    if (date) {
      const newDateTime = date.clone().set({
        hour: input.pickupDateTime?.hour() || 0,
        minute: input.pickupDateTime?.minute() || 0,
      });
      setInput({ pickupDateTime: newDateTime });
    }
  };

  const handleTimeChange = (time: any) => {
    if (time) {
      const newDateTime = (input.pickupDateTime || moment()).clone().set({
        hour: time.hour(),
        minute: time.minute(),
      });
      setInput({ pickupDateTime: newDateTime });
    }
  };

  const handleSubmit = () => {
    try {
      const value = PickupDateModalSchema.validateSync(input);
      if (value) onSubmit({ pickupDateTime: moment(value.pickupDateTime), orderID });
    } catch (err) {
      console.log(err);
      const { path, value }: any = errorHandler.validation(err);

      setError &&
        setError({
          ...error,
          [path]: t(`${value}`, { field: t(`label.${path}`) }),
        });
    }
  };

  return (
    <div className="delivery-date-modal">
      <div className="ddm-header">
        <div className="ddm-title">{t("title.changeDeliveryDate")}</div>
      </div>
      <div className="ddm-container">
        <Row gutter={[0, 16]}>
          <Col span={24}>
            <DatePicker
              isRequired={true}
              isError={error.pickupDateTime}
              suffix={<CalendarOutlined />}
              label={t("label.pickupDate")}
              value={input.pickupDateTime}
              onChange={handleDateChange}
              format="YYYY-MM-DD"
            />
            <AlertBox text={error.pickupDateTime} />
          </Col>
          <Col span={24}>
            <TimePicker
              isRequired={true}
              isError={error.pickupDateTime}
              label={t("label.pickupTime")}
              value={input.pickupDateTime}
              onChange={handleTimeChange}
              format={"hh:mm a"}
            />
            <AlertBox text={error.pickupDateTime} />
          </Col>
        </Row>
      </div>
      {error?.general && <div className="u-info u-error">{error.general}</div>}
      <div className="ddm-btn-container">
        <Button
          label={t("action.cancel")}
          isDisabled={isLoading}
          onClick={() => onClose()}
        />
        <Button
          label={t("action.submit")}
          type="primary"
          isLoading={isLoading}
          onClick={() => handleSubmit()}
        />
      </div>
    </div>
  );
};

export default PickupDateModal;
